import {
  GET_CHATS_SUCCESS,
  SAVE_CHATS_SUCCESS,
  RESET_CHATS,
  GET_CHATS_COUNTS_SUCCESS,
  GET_CHATS_PENDING,
  GET_CHATS_FAILURE,
  DELETE_CHAT_PENDING,
  DELETE_CHAT_SUCCESS,
  DELETE_CHAT_FAILURE,
  EDIT_CHAT_PENDING,
  EDIT_CHAT_SUCCESS,
  EDIT_CHAT_FAILURE,
} from './chatTypes';

const initialState = {
  chats: [],
  chatCount: 0,
  isLoading: false,
  error: false,
  errorCode: null,
};

const ChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHATS_PENDING: {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorCode: null,
      };
    }
    case GET_CHATS_SUCCESS: {
      let chatAllowSpecialChars= action.chatAllowSpecialChars;
      let additionalRestriction= ["÷", "₹", "¥", "₩", "#","^","~","<",">","|","{","}","\\[","\\]"]; 
      additionalRestriction.filter((item,index)=> {let findList=chatAllowSpecialChars.indexOf(item)
        if(findList>-1){
          additionalRestriction.splice(index,1);
        }
      })
      return {
        ...state,
        chats: action.chats,
        chatAllowSpecialChars: action.chatAllowSpecialChars,
        chatAllowValidationSpecialChars: action.chatAllowValidationSpecialChars,
        additionalCharRestict: additionalRestriction,
        isLoading: false,
        error: false,
        errorCode: null,
        isChatEnable:action.isChatEnable,
      };
    }
    case GET_CHATS_FAILURE: {
      return {
        ...state,
        chats: [],
        error: true,
        errorCode: action.error,
        isLoading: false,
      };
    }
    case RESET_CHATS: {
      return {
        ...state,
        chats: [],
        error: false,
        isLoading: false,
        errorCode: null,
      };
    }
    case SAVE_CHATS_SUCCESS: {
      return {
        ...state,
        chats: action.chats,
      };
    }
    case GET_CHATS_COUNTS_SUCCESS: {
      return {
        ...state,
        chatCount: action.data.chatCount,
      };
    }
    case DELETE_CHAT_PENDING: {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorCode: null,
      };
    }
    case DELETE_CHAT_SUCCESS:
    case DELETE_CHAT_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case EDIT_CHAT_PENDING: {
      return {
        ...state,
        isLoading: true,
        error: false,
        errorCode: null,
      };
    }
    case EDIT_CHAT_SUCCESS:
    case EDIT_CHAT_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};

export default ChatReducer;
